import { PropType } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import UnlockModuleOrderAgencyListItemEntity from '@/entity/unlock-module-order-agency/UnlockModuleOrderAgencyListItemEntity';

type Props = SetupProps<typeof UnlockModuleOrderAgencyCardSetupService.props>

export default class UnlockModuleOrderAgencyCardSetupService extends BaseSetupService<Props> {
	static readonly props = {
		selected: Boolean,
		agency: {
			type: Object as PropType<ICompanyWithOrderPluginModel>,
			required: true as const,
		},
	};

	agency = new UnlockModuleOrderAgencyListItemEntity(this.props.agency);

	constructor (props?: Props) {
		super(props);
	}
}
